<template>
  <div class="form-group radio-group v-stack gap-2">
    <div class="radio v-stack gap-1" v-if="options.length">
      <Radio
        v-for="option in options"
        :checked="value === option.id"
        @update:checked="onCheck(option.id, $event)"
        :id="[name, option.id].join('_')"
        :name="name"
        :label="option.label"
        :key="option"
      />
    </div>
  </div>
</template>

<script>
import Radio from "@/components/Form/Radio.vue";

export default {
  name: "RadioGroup",
  emits: ["update:value"],
  components: {
    Radio,
  },
  props: {
    name: {
      value: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
      default() {
        return ""
      }
    },
    options: {
      type: Array,
      required: true,
      validator: (value) => {
        const hasLabelKey = value.every((option) =>
          Object.keys(option).includes("label")
        );
        const hasIdKey = value.every((option) =>
          Object.keys(option).includes("id")
        );
        return hasLabelKey && hasIdKey
      },
    }
  },
  data() {
    return {
      config: {},
      model: this.value || null,
      Drupal: this.$drupal,
    }
  },
  methods: {
    onCheck(optionId, checked) {
      if (checked) {
        this.model = optionId
      }

      this.$emit("update:value", this.model)
    }
  }
};
</script>
